import { render, staticRenderFns } from "./testCarousel.vue?vue&type=template&id=4333a65a&scoped=true&"
import script from "./testCarousel.vue?vue&type=script&lang=js&"
export * from "./testCarousel.vue?vue&type=script&lang=js&"
import style0 from "./testCarousel.vue?vue&type=style&index=0&id=4333a65a&scoped=true&lang=css&"
import style1 from "./testCarousel.vue?vue&type=style&index=1&lang=css&"
import style2 from "./testCarousel.vue?vue&type=style&index=2&id=4333a65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4333a65a",
  null
  
)

export default component.exports